export const activesDtcsStatus = {
    1: 'Inactiva',
    2: 'Activa'
}